import styles from "./Projects.module.css";
import SectionHeader from "shared/components/Header/SectionHeader";
import { Link } from "react-router-dom";
import { useFetch } from "shared/utils/useFetch";
import { trackProjectClick } from "shared/services/analytics";

const Projects = () => {
  const { data: projects } = useFetch("/api/featured-projects", []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <SectionHeader title="Recent Projects and Achievements" />

        <div className={styles.projectsContainer}>
          {projects.map((project) => {
            return (
              <Link
                key={project.slug}
                to={`/projects/${project.slug}`}
                className={styles.linkWrapper}
                onClick={() => trackProjectClick(project.slug)}
              >
                <div className={styles.projectCard}>
                  <div className={styles.projectImage}>
                    <img src={project.cover} alt={project.title} loading="lazy" />
                  </div>
                  <div className={styles.projectBanner}>
                    <h2>{project.title}</h2>
                    <p>{project.subtitle}</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Projects;
